<template>
    <div id="Step">
        <section class="section home-section">
            <div class="inner-wrap container">
                <div class="row pr-sm-3 pl-sm-3 pt-2 mt-4 ">
                    <img v-if="field.data.selected == 1" class="w-100 h-100" src="../../assets/img/step-1.svg">
                    <img v-if="field.data.selected == 2" class="w-100 h-100" src="../../assets/img/step-2.svg">
                    <img v-if="field.data.selected == 3" class="w-100 h-100" src="../../assets/img/step-3.svg">
                    <img v-if="field.data.selected == 4" class="w-100 h-100" src="../../assets/img/step-4.svg">
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: 'Step',
    components:{
    },
    props:{
        field: {
            type: Object,
            default: {
                box: true
            }
        },
    },
    data() {
        return {
        }
    },
    methods: {
    },
    mounted() {
        
    }
}
</script>